import type { User } from "firebase/auth";
import { auth } from "../lib/firebase";
import { getConfig } from "../config/environment";
import type { PropertyValuationData } from "../types/valuation";

interface ValuationRecordInput {
  userId: string;
  propertyDetails: PropertyValuationData;
  organizationId?: string;
  authUser?: Pick<User, "uid" | "getIdToken">;
  sourceUrl?: string;
}

export async function createValuationRecord({
  userId,
  propertyDetails,
  organizationId,
  authUser,
  sourceUrl,
}: ValuationRecordInput): Promise<void> {
  try {
    const currentUser = authUser || auth.currentUser;
    if (!currentUser || currentUser.uid !== userId) {
      throw new Error(
        "Authenticated Firebase user is required to create valuation record"
      );
    }

    const token = await currentUser.getIdToken();
    const apiBaseUrl = getConfig().cloudRunServices.graphqlUrl.replace(
      /\/graphql\/?$/,
      ""
    );
    const pageUrl =
      sourceUrl ||
      (typeof window !== "undefined" ? window.location.href : undefined);
    const response = await fetch(`${apiBaseUrl}/api/v1/valuation-records`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        propertyId: propertyDetails.id,
        estimatedValue: propertyDetails.estimatedValue,
        propertyInfo: {
          ...propertyDetails.propertyInfo,
          propertyType: propertyDetails.propertyType,
        },
        organizationId,
        sourceUrl: pageUrl,
        valuationSource: "web_experience",
      }),
    });

    if (!response.ok) {
      const detail = await response.text();
      throw new Error(
        `Failed to create valuation record: ${response.status} ${detail}`
      );
    }
  } catch (error) {
    console.error("Error creating valuation record:", error);
    throw error;
  }
}
